/* semeia-disable-reexport */

// TODO: this has been created from doctor-specialty-code-to-key.js
// We need to factorize all this
export default class Specialty {
  id: string;
  codes: string[];

  constructor({ id, codes }: { id: string; codes?: string[] }) {
    this.id = id;
    this.codes = codes || [];
  }

  // codes stored in this.codes attribute can have the following format :
  // G15_10/SM02
  // G15_10/SM03
  // G15_110/SM02
  // We have to remote the prefix (delimiter is _)
  // And check if provided parameter exaclty matches one of the codes' second part
  hasCode(_code: string): boolean {
    return this.codes
      .map(code => code.split("_")[1])
      .some(code => code == _code);
  }
}
